import { render } from "./LogisticsShkureno.vue?vue&type=template&id=2fffd4ce&scoped=true"
import script from "./LogisticsShkureno.vue?vue&type=script&lang=js"
export * from "./LogisticsShkureno.vue?vue&type=script&lang=js"

import "./LogisticsShkureno.vue?vue&type=style&index=0&id=2fffd4ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fffd4ce"]])

export default __exports__